import React from "react"
import { ADD } from "../../include/constant"
import ShopForm from "../common/ShopForm"
import SuperAdminHeader from "./Header"

const SuperAdminAddShop = () => {
    return <SuperAdminHeader >
        <div className="fixed-top-bar">
        <ShopForm
            title="Add Shop"
            type={ADD}
        />
    </div>
    </ SuperAdminHeader>
}

export default SuperAdminAddShop